<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :orderCode="orderCode"
        :fabricCode="fabricCode"
        :params="params"
        @reload="reload"
        @query="getData"
        @reset="resetPage"
        @batchDel="batchDel"
      >
      </page-header>
    </page-main>
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'

export default {
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable],
  props: {
    orderCode: {
      type: String,
      default: '',
    },
    fabricCode: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .orderGoodsSpecFabricListApi({
          orderCode: this.orderCode,
          fabriclCode: this.fabricCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .orderGoodsSpecFabricDelApi({goodsSpecFabriclCodeList: listCode})
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
